module.exports = __webpack_public_path__ + "static/media/person2.d4f6529e.png";